/**
 * Copilot 输入框底部按钮 Hover 提示组件（纯 UI）
 *
 * 用于 Copilot 场景下「仅 click 打开面板、hover 展示引导文案」的按钮，
 * 如思考模式、图表选择等。须包在 Dropdown 外层（对齐 SkillCard / UploadFileButton），
 * 不可放在 Dropdown 的 button 子节点内，否则 hover tip 可能无法稳定触发。
 *
 * 样式复用 `dba-upload-icon-tip` 与 `dba-nav-menu-overlay`。
 */
import React from 'react';
import CommonBubble from '@home/components/CommonBubble';

/**
 * InputTriggerHoverTip 组件 Props
 */
interface IInputTriggerHoverTipProps {
  /** 是否展示 hover 提示；Copilot click-only 场景传 true */
  enabled?: boolean;
  /** 气泡文案内容 */
  content?: React.ReactNode;
  /** 被包裹的触发器节点（通常为 Dropdown 或其外层容器） */
  children: React.ReactNode;
  /** 触发器 className，默认 `dba-upload-icon-tip` */
  className?: string;
  /** 外部强制隐藏气泡（如 Dropdown 面板已打开时传 true） */
  suppressVisible?: boolean;
}

/**
 * Copilot 输入框底部按钮 hover 提示
 *
 * @param props - 组件属性
 * @returns enabled 且有 content 时返回带气泡与 stopPropagation 的包裹层，否则直接返回 children
 */
const InputTriggerHoverTip: React.FC<IInputTriggerHoverTipProps> = ({
  enabled = false,
  content,
  children,
  className = 'dba-upload-icon-tip',
  suppressVisible = false,
}) => {
  if (!enabled || !content || suppressVisible) {
    return <>{children}</>;
  }

  return (
    <CommonBubble
      placement="top"
      trigger="hover"
      content={content}
      className={className}
      overlayClassName="dba-nav-menu-overlay"
    >
      <div onClick={(e) => e.stopPropagation()}>{children}</div>
    </CommonBubble>
  );
};

export default InputTriggerHoverTip;
